import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { EditProjectContextProps } from "../../EditProjectContext";

export default ({ project, setProject }: EditProjectContextProps) => {
  const ltlPipelines = project?.ltlPipelines?.map((item: LtlPipelineViewModel) => {
    return {
      ...item,
      routing: [],
      IsFinished: false,
    };
  });

  setProject({ ...project, ltlPipelines });
};
